import type { IRecordIconProps } from './IRecordIconProps';
import { RECORD_ICONS } from './recordIcons';

/** Іконка панелі дій запису з контурів прототипу (декоративна: кнопку підписує її aria-label). */
export function RecordIcon({ name, size = 16, strokeWidth = 1.8, filled = false }: IRecordIconProps) {
  return (
    <svg className="icon" width={size} height={size} viewBox="0 0 24 24" fill={filled ? 'currentColor' : 'none'} stroke="currentColor"
      strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" aria-hidden>
      {(RECORD_ICONS[name] ?? []).map((shape) => {
        const [kind, args] = shape.split(':');
        const n = (args ?? '').split(',').map(Number);
        if (kind === 'c' && args) return <circle key={shape} cx={n[0]} cy={n[1]} r={n[2]} />;
        if (kind === 'r' && args) return <rect key={shape} x={n[0]} y={n[1]} width={n[2]} height={n[3]} rx={n[4]} />;
        return <path key={shape} d={shape} />;
      })}
    </svg>
  );
}
